// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Дизайн-мислення» (Design thinking, ключ `dthink`, група `creative`). */
export const designThinkingManifest: IModuleManifest = {
  key: 'dthink',
  group: 'creative',
  slug: 'design-thinking',
  prefix: 'DTH',
  name: { en: 'Design thinking', uk: 'Дизайн-мислення' },
  entities: [
    { key: 'dthink', slug: 'dthink', name: { en: 'Design projects', uk: 'Дизайн-проєкти' }, main: true },
    { key: 'dtins', slug: 'dtins', name: { en: 'Research insights', uk: 'Інсайти' }, main: false },
    { key: 'dtproto', slug: 'dtproto', name: { en: 'Prototypes', uk: 'Прототипи' }, main: false },
  ],
  loadState: () => import('./state/designThinkingSlice').then((m) => m.designThinkingSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
